(function() {
    'use strict';

    angular
        .module('app.proyectos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/proyectos',
                config: {
                    templateUrl: 'app/proyectos/list.html',
                    controller: 'proyectos.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-proyecto/:id?',
                config: {
                    templateUrl: 'app/proyectos/edit.html',
                    controller: 'proyectos.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
